

// export const apiConstant = { 
//     loginUrl: "http://localhost:8080/genmaster/",
//     genmasterTokenUrl: "http://localhost:8080/",
//     restProjectUrl: "http://localhost:7777/",
// //  projectBaseUrl: "https://amerkilaspices.com/",
//   projectBaseUrl: "http://localhost:7779/",
//   //  projectBaseUrl: "/",
//    //  projectBaseUrl: "/"
//   //  projectBaseUrl: "/amerkilaspices/"
// }

// if (typeof window !== 'undefined') 
//    window['apiBaseUrl'] = apiConstant.projectBaseUrl;




export const apiConstant = { 
    loginUrl: "http://localhost:8080/genmaster/",
    genmasterTokenUrl: "http://localhost:8080/",
    restProjectUrl: "http://localhost:7777/",
//  projectBaseUrl: "https://amerkilaspices.com/",
  // projectBaseUrl: "http://localhost:7779/",
  //  projectBaseUrl: "/",
     projectBaseUrl: "/"
  // projectBaseUrl: "/amerkilaspices/"
}

if (typeof window !== 'undefined') 
   window['apiBaseUrl'] = apiConstant.projectBaseUrl;
